<app-loader></app-loader>
<app-header *ngIf="ExamStatus==false"></app-header>
<!-- <div> -->
<!-- <div class="left-menu close" [hidden]="isShowleftMenu==false">
    <app-left-menu></app-left-menu>

  </div> -->
<!-- <section> -->
<!-- <div class="home-content" [hidden]="isShowleftMenu==false">
            <i class='bx bx-menu'></i>
            <span class="text"></span>
        </div> -->
<!-- <router-outlet></router-outlet>
  </section>
</div> -->
<router-outlet></router-outlet>
<app-footer *ngIf="ExamStatus==false"></app-footer>